/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReturnPolicy_item = {
    readonly returnPolicy: {
        readonly accept: boolean | null;
        readonly buyerCopy: {
            readonly returnPolicySection: {
                readonly htmlCopy: string | null;
            } | null;
            readonly returnPolicySectionCtaCopy: {
                readonly htmlCopy: string | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "PdpSharedDetailReturnPolicy_item";
};
export type PdpSharedDetailReturnPolicy_item$data = PdpSharedDetailReturnPolicy_item;
export type PdpSharedDetailReturnPolicy_item$key = {
    readonly " $data"?: PdpSharedDetailReturnPolicy_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReturnPolicy_item">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "htmlCopy",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "PdpSharedDetailReturnPolicy_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "returnPolicy",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "ReturnPolicy",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accept",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "buyerCopy",
          "storageKey": null,
          "args": null,
          "concreteType": "ReturnPolicyCopy",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "returnPolicySection",
              "storageKey": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "plural": false,
              "selections": (v0/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "returnPolicySectionCtaCopy",
              "storageKey": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "plural": false,
              "selections": (v0/*: any*/)
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '11c16a2eddb4da761195970db640f503';
export default node;
